export const CREATE_MALL_STAFF = 'create_mall_staff';
